function getQuantityLabelCount({count}) {
    return `${count || 0}`;
}

function getQuantityLabelTerm({count, singular, plural}) {
    return count === 1 ? `${singular}` : `${plural}`;
}

function getQuantityLabel({label, count, singular, plural}) {
    if (label) {
        return label;
    }

    const labelCount = getQuantityLabelCount({count});
    const labelTerm = getQuantityLabelTerm({count, singular, plural});

    return `${labelCount} ${labelTerm}`;
}

function toString(value) {
    return String(value);
}

export {
    getQuantityLabelCount,
    getQuantityLabelTerm,
    getQuantityLabel,
    toString
};
